// Relative, not '@/': the e2e unit tests import this file, and their tsconfig has no alias.
import type { DemoRequestDto } from '../sdk/email/types';

/**
 * What a demo request tells PostHog: where the lead came from, never who they are.
 * Built from an explicit list rather than by removing fields, so a contact field added
 * to the form later cannot reach analytics by default.
 */
export function demoRequestEventProperties(payload: DemoRequestDto): Record<string, string | undefined> {
  return {
    industry: payload.industry,
    heard_about: payload.heard_about,
    landing_page: payload.landing_page,
    referrer: payload.referrer,
    utm_source: payload.utm_source,
    utm_medium: payload.utm_medium,
    utm_campaign: payload.utm_campaign,
    delivery: payload.source,
  };
}
